export enum IRAAutoMaxSubmissionActionTypes {
  // SUBMISSION ACTIONS
  IRA_AUTO_MAX_SUBMISSION = 'IRA_AUTO_MAX_SUBMISSION',
  IRA_AUTO_MAX_SUBMISSION_PENDING = 'IRA_AUTO_MAX_SUBMISSION_PENDING',
  IRA_AUTO_MAX_SUBMISSION_FULFILLED = 'IRA_AUTO_MAX_SUBMISSION_FULFILLED',
  IRA_AUTO_MAX_SUBMISSION_REJECTED = 'IRA_AUTO_MAX_SUBMISSION_REJECTED',
}
